// extracted by mini-css-extract-plugin
module.exports = {"descope-wrapper":"styles_descope-wrapper__1SqfU"};